<template lang="pug">
  v-card.mx-auto
    v-img.white--text.align-end(:src='item.picture')
      v-card-title {{ item.name }}
    v-card-actions
      v-spacer
      v-btn(icon, tile, @click='actions.view(item.id)', color='primary')
        v-icon far fa-eye
      v-btn(v-if='complete', icon, tile, @click='actions.update(item.id)', color='primary')
        v-icon fas fa-edit
      v-btn(v-if='complete', icon, tile @click='actions.erase(item.id)', color='secondary')
        v-icon far fa-trash-alt
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    complete: {
      type: Boolean,
      required: false,
      default: false
    },
    actions: {
      type: Object,
      required: true
    }
  },
}
</script>
